/* eslint-disable  @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useMemo } from "react";
import {
  BreadcrumbComponent,
  AlertComponent,
} from "../../../common/components";
import RenewalRateSummary from "./renewal-rate-summary/renewal-rate-summary";
import SubscriptionGrowthTrend from "./subscription-growth-trend/subscription-growth-trend";
import SubscriptionReportFilter from "./subscription-report-filter/subscription-report-filter";
import { useSetLoading } from "../../../common/hooks/appearance";
import {
  getSubscriptionReports,
  addSubscriptionReports,
} from "../../../api/payment";
import "./subscription-report.scss";
import MODULES from "../../../constants/modules";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import { useLogin } from "../../../common/hooks/useUser";

const SubscriptionReport = () => {
  const [breadcrumbLink, setBreadcrumbLink] = useState<any>([
    {
      label: "Payments",
      link: "#",
      handleClick: () => {},
    },
    {
      label: "Subscription Reports",
      link: "#",
      handleClick: () => {},
    },
  ]);
  const [loading, setLoading] = useState<boolean>(false);
  const [reportsData, setReportsData] = useState<any>(null);
  const [filterDate, setFilterDate] = useState<any>({});
  const [alertMessage, setAlertMessage] = useState<string | null>(null);
  const [alertType, setAlertType] = useState<
    "error" | "success" | "info" | "warning"
  >("info");
  const [alertOpen, setAlertOpen] = useState<boolean>(false);

  const loginDetails = useLogin();
  const isEmailConfigured = loginDetails?.isEmailConfigured;
  const { canExport } = useResourcePermissions(MODULES.EXPORT);

  const fetchLeadReports = async () => {
    setLoading(true);
    try {
      const response = await getSubscriptionReports({
        startDate: filterDate?.start,
        endDate: filterDate?.end,
      });
      setReportsData(response?.data?.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message || "Failed to fetch campaigns"
      );
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  const handleAddSubscriptionReports = async (data: any, params: any) => {
    setLoading(true);
    try {
      await addSubscriptionReports(data, params);
      setAlertMessage("Report generated successfully");
      setAlertType("success");
      setAlertOpen(true);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setAlertMessage(error?.response?.data?.message || "Failed to fetch");
      setAlertType("error");
      setAlertOpen(true);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filterDate?.start && filterDate?.end) {
      fetchLeadReports();
    }
  }, [filterDate]);

  useEffect(() => {
    if (!filterDate?.start && !filterDate?.end) {
      fetchLeadReports();
    }
  }, [filterDate]);

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="subscription-report-wrapper">
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
        </div>
        <div>
          <div className="user-reports-content">
            <SubscriptionReportFilter
              setFilterDate={setFilterDate}
            />
            <SubscriptionGrowthTrend
              subscriptionGrowthTrend={reportsData?.subscriptionGrowthTrend}
              handleAddSubscriptionReports={handleAddSubscriptionReports}
              enableExport={canExport}
            />
            <RenewalRateSummary
              handleAddSubscriptionReports={handleAddSubscriptionReports}
              RenewalRateSummaryData={reportsData?.renewalRateSummary}
              enableExport={canExport}
            />
          </div>
        </div>
        <AlertComponent
          message={alertMessage}
          type={alertType ?? "info"}
          open={alertOpen}
          onClose={() => setAlertOpen(false)}
        />
      </div>
    </>
  );
};

export default SubscriptionReport;
